<script setup>
import {computed, ref, watch} from 'vue';
import {
  searchType,
  total,
  checkboxs,
  uncheckedList,
  tableData,
  init,
  search,
  formData, pagination, headerInfo, checkList
} from './index';
import request from "@/service/request";
import {exportProjectStock, exportProjectStockTime} from "@/service/api";
import {cityFilterMethod, exportFile} from "@/tool/public";
import SelectRow from "@/view/dataExport/components/selectRow.vue";
import {CircleCheck, Delete, Download} from "@element-plus/icons-vue";
import {permissionOfDownload} from "@/view/dataExport/standardProject";
const props = defineProps(['visible'])
const handleCurrentChange  = (val) => {
    pagination.value.pageNum = val
}

const exportInfo = async () => {
    const {date, address} = formData.value
    let params = {
        // ...formData.value,
        // ...pagination.value,
        // startDate: date.length ? date[0] : '',
        // endData: date.length ? date[1] : '',
        // provCode: address[0] ? address[0] : '',
        // cityCode: address[1] ? address[1] : '',
        // areaCode: address[2] ? address[2] : '',
        quarter: formData.quarter,
        ...formData.value,
        ...pagination.value,
        startDate: date.length ? date[0] : '',
        endData: date.length ? date[1] : '',
        provCode: formData.value.provCode,
        cityCode: formData.value.cityCode,
        areaCode: formData.value.areaCode,
        selectedColumns: [...checkList.value],
    }
    delete params.address
    delete params.date
    let data = await request({
        url: exportProjectStock,
        method: 'post',
        data: {
            ...params,
            selectedColumns: [...checkList.value]
        },
        download:true,
        responseType: 'blob',
    })
    let str = '高标仓项目层级存量数据'
    exportFile(data,str)
    await exportTime()

}
const exportTime = async () =>
{
    const {date, address} = formData.value
    let params = {
        // ...formData.value,
        // ...pagination.value,
        // startDate: date.length ? date[0] : '',
        // endData: date.length ? date[1] : '',
        // provCode: address[0] ? address[0] : '',
        // cityCode: address[1] ? address[1] : '',
        // areaCode: address[2] ? address[2] : '',
        quarter: formData.quarter,
        ...formData.value,
        ...pagination.value,
        startDate: date.length ? date[0] : '',
        endData: date.length ? date[1] : '',
        provCode: formData.value.provCode,
        cityCode: formData.value.cityCode,
        areaCode: formData.value.areaCode,
        selectedColumns: [...checkList.value],
    }
    delete params.address
    delete params.date
    await request({
        url: exportProjectStockTime,
        method: 'post',
        data: {
            ...params,
            selectedColumns: [...checkList.value]
        },
    })
}



const currentFormItem = computed(()=>{
  console.log('lllllllllllllllllllllllllllllll');
  console.log(headerInfo.value.provinces);
  console.log('99999999999999999999999999999');
  
  
  
    return [
        {prop: "quarter", label: "季度", type: 'select', options: headerInfo.value.quarter, placeholder: "请选择"},
        {prop: "projectDeveloper", label: "开发商", type: 'input',  placeholder: "请输入"},
        {
          prop: "address",
          label: "省/市/区",
          type: 'cascader',
          props: {checkStrictly: true, value:'code', label:'name', multiple: true, checkStrictly: true  },
          placeholder: "请选择",
          options: headerInfo.value.provinces
        }
    ]
})

const arr2Object = (c, n) => {
  let key = n['name'];
  c[key] = n;
  return c;
}

const tableHead = computed(() => {
  return checkboxs.value.filter(e => !e['checked'])
})

// 处理字段的选中或取消
const columnsDict = computed(() => {
  return checkboxs.value.reduce(arr2Object, {})
})

const basicInfoRef = ref(['wlCode', 'projectDeveloper', 'projectName']);
const basicInfo = computed(() => {
  return checkboxs.value.length > 0 ? basicInfoRef.value.map(key => columnsDict.value[key]) : [];
})
const changeBasicInfo = (v) => {
  if(v['checked']){
    uncheckedList.value.push(v);
    checkList.value = checkList.value.filter(e => e !== v['name']);
  }else{
    checkList.value.push(v['name']);
    uncheckedList.value = uncheckedList.value.filter(e => e['name'] !== v['name']);
  }
}
const onchange = (v) => {
  console.log('333333333333333333');
  console.log(v);
  console.log(v[1]);
  console.log(v.length);
  var arr = []
  var arr2 = []
  var provCode = ''
  var cityCode = ''
  var areaCode = ''
  for (var i in v) {
    console.log(v[i].length);
    var num = v[i].length
    if (num == 1) {
      arr.push(v[i][0])
      provCode += ',' + v[i][0]
    }
    if (num > 1) {
      if (!arr.includes(v[i][0])) {
        if (num > 2) {
          if (!arr2.includes(v[i][1])) {
            areaCode += ',' + v[i][2]
          }
        } else {
          cityCode += ',' + v[i][1]
          arr2.push(v[i][1])
        }
      }
    }
  }
  console.log('=----------------=-=-==-==-=-=-=-');
  console.log('provCode   ' + provCode.substring(1));
  formData.value.provCode = provCode.substring(1)
  console.log('cityCode   ' + cityCode.substring(1));
  formData.value.cityCode = cityCode.substring(1)
  console.log('areaCode   ' + areaCode.substring(1));
  formData.value.areaCode = areaCode.substring(1)
  console.log('................................');
  
  console.log(arr);
  
  

  console.log(formData);
  
  console.log('66666666666666666');
}
const clearHandleSelect = (v) => {
  v['checked'] = false;
  uncheckedList.value = uncheckedList.value.filter(e => e['name'] !== v['name']);
  checkList.value = checkboxs.value.map(({name}) => name)
}

// 项目位置
const projectLocationRef = ref(['province', 'city', 'area', 'address', 'gpsLon', 'gpsLat']);
const projectLocation = computed(() => {
  return checkboxs.value.length > 0 ? projectLocationRef.value.map(key => columnsDict.value[key]) : [];
})
// 项目参数
const projectParamsRef = ref(['areaTotal', 'vacancyRate', 'effectiveRent', 'buildingState',
  'buildingArea', 'maxBuiltTime', 'newSupply', 'netTakeup']);
const projectParams = computed(() => {
  return checkboxs.value.length > 0 ?  projectParamsRef.value.map(key => columnsDict.value[key]) : [];
})

// 建筑参数
const buildingParamsRef = ref(['rptBuildingTypeNames', 'builtUpArea', 'buildingNumber',
  'floorNumber', 'floorHeight', 'rptStorageTypeNames', 'dischargeCargo', 'bearing', 'platformType'
  , 'awningDimension', 'interColumniation', 'platformSize']);
const buildingParams = computed(() => {
  return checkboxs.value.length > 0 ? buildingParamsRef.value.map(key => columnsDict.value[key]) : [];
})
const fireConfigRef = ref(['fireLevel', 'fireFacilities', 'distributionCapacity',
  'campusSecurity', 'floorTypeNames', 'parkFacilities', 'rptFacilities']);
// 消防配置
const fireConfig = computed(() => {
  return checkboxs.value.length > 0 ? fireConfigRef.value.map(key => columnsDict.value[key]) : [];
})
// 土地信息
const landInfoRef = ref(['landUse', 'landProperty', 'coveredArea']);
const landInfo = computed(() => {
  return checkboxs.value.length > 0 ? landInfoRef.value.map(key => columnsDict.value[key]) : [];
})

// 现有存量（㎡）、空置率、有效租金（元/㎡·月）
const requireFields = ref({
  'projectName': '项目名称',
  'projectDeveloper': '开发商',
  'wlCode': 'WL码',
  'province': '省',
  'city': '市',
  'area': '区县',
  'address': '详细地址',
  'gpsLon': 'GPS经度',
  'gpsLat': 'GPS纬度',
  'areaTotal': '现有存量(m²)',
  'vacancyRate': '空置率',
  'effectiveRent': '有效租金(元/m²·月)',
})
const resetSelected = () => {
  checkList.value =checkboxs.value.map(({name}) => name)
  checkboxs.value.forEach(e => e['checked'] = false);
  uncheckedList.value = [];
}

watch(props, () => {
  if(props.visible) init()
}, {immediate: true});


</script>
<template>
    <div v-if="visible" class="data-container">
        <div class="ed-project-search">
<!--        <p style="overflow-y: auto;font-size: 12px;height: 200px;">{{JSON.stringify(headerInfo.provinces)}}</p>-->
            <div>
                <div class="app-search-form" style="align-items: center">
                    <p style="width: 100px;">数据时间</p>
                    <div v-for="(item,index) in currentFormItem.filter(item=>!item.hidden)"
                         :class="{'app-sf-no-mr': currentFormItem && index === currentFormItem.length - 1}"
                         class="app-search-fitem">
                        <span>{{ item.label }}：</span>
                        <div class="app-search-ops">
                            <template v-if="item.type === 'input'">
                                <el-input v-model="formData[item.prop]" :placeholder="item.placeholder" clearable size="small"></el-input>
                            </template>
                            <template v-else-if="item.type === 'select'">
                                <el-select  v-model="formData[item.prop]" :placeholder="item.placeholder" clearable collapse-tags multiple
                                           size="small">
                                    <el-option v-for="v in item.options" :key="v" :label="v"
                                               :value="v">{{v}}</el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.type === 'cascader'">
                                <el-cascader
                                   filterable
                                   :filter-method="cityFilterMethod"
                                   :options="item.options"
                                   :placeholder="item.placeholder"
                                   :props="item.props"
                                   @Change="onchange"
                                   collapse-tags='true'
                                   clearable
                                   size="small"
                                />
                            </template>
                            <template v-else-if="item.type === 'mRange'">
                                <div class="app-search-fitem-range">
                                    <el-input v-model="formData[item.prop[0]]" :placeholder="item.placeholders[0]" size="small"/>
                                    <span>-</span>
                                    <el-input v-model="formData[item.prop[1]]" :placeholder="item.placeholders[1]" size="small"/>
                                </div>
                            </template>
                            <template v-else-if="item.type === 'daterange'">
                                <el-date-picker v-model="formData[item.prop]" :end-placeholder="item.placeholders[1]" :start-placeholder="item.placeholders[0]"
                                                range-separator="-"
                                                size="small" type="daterange"/>
                            </template>
                        </div>
                    </div>
                </div>

                <!--基础信息-->
                <select-row
                    name="基础信息"
                    :values="basicInfo"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
                <select-row
                    name="项目位置"
                    :values="projectLocation"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
                <select-row
                    name="项目参数"
                    :values="projectParams"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
                <select-row
                    name="建筑参数"
                    :values="buildingParams"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
                <select-row
                    name="消防及配套"
                    :values="fireConfig"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
                <select-row
                    name="土地参数"
                    :values="landInfo"
                    @onChange="changeBasicInfo"
                    :requires="requireFields"
                />
            </div>
        </div>
        <hr style="border:1px solid #ccc;">
        <div class="app-search-btns" >
          <el-button size="small" :icon="Delete" @click="resetSelected">清空选择</el-button>
          <el-button size="small" :icon="CircleCheck" type="primary" @click="search">确认选择</el-button>
        </div>

        <dl class="dl-row">
          <dt>未选中字段</dt>
          <dd class="dd-remove"
              v-for="v in uncheckedList"
              :key="v['name']"
              @click="clearHandleSelect(v)"
          >
            <span class="dd-close">x</span>
            {{v['text']}}
          </dd>
        </dl>

        <div class="export-container">
            <div class="ed-project-table-box-36">
                  <div class="rs-el-table table-container">
                      <el-table
                          :key="searchType"
                          :data="tableData"
                          show-overflow-tooltip
                          style="font-size: 12px;height: 100%;"
                      >
                        <el-table-column
                            v-for="item in tableHead"
                            :key="item.name"
                            :label="item.text"
                            :prop="item.name"
                            width="200"
                            align="center"/>
                      </el-table>
                  </div>
                  <div class="ed-project-pagination" style="display: flex; height: 40px;">
                      <el-pagination
                          :total="total"
                          :page-size="pagination.pageSize"
                          background
                          layout="prev, pager, next, jumper"
                          small
                          @current-change="handleCurrentChange"
                      />
                      <a
                        v-if="permissionOfDownload"
                         class="download-link"
                         href="javascript:;"
                         @click="exportInfo"
                      >
                        <el-icon style="margin-right: 4px;"><Download /></el-icon>导出数据
                      </a>
                  </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
@import "../../../assets/css/public.less";
@import "../index.less";
.export-container{
  flex-basis: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.data-container{
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 0;
}
.ed-project-table-box-36{
  flex-basis: 100%;
  min-height: 0;

  display: flex;
  flex-direction: column;
}

.table-container{
  flex-basis: 100%;
  min-height: 0;
}

.dl-row{
  font-size: 12px;
  display: flex;
  padding: 4px 0;

  & dt{
    color: #999;
    font-weight: 600;
  }
  & dd{
    padding: 0 6px;
    color: #999;
    cursor: pointer;
  }
}
.download-link{
  font-size: 12px;
  line-height: 40px;
  text-decoration: none;
  padding: 0 20px;
}
.dd-close{
  float: right;
  display: none;
}
.dd-remove{
  &:hover{
    .dd-close{
      display: block;
    }
  }
}
.el-cascader__tags {
  height: 16px !important;
}
.app-search-form .app-search-fitem span {
  margin-top: 1px !important;
  height: 15px;
}
.el-cascader__search-input {
  margin-top: -5px;
}
.el-cascader--small {
  width: 100%;
}
</style>